import { render, staticRenderFns } from "./Processes.vue?vue&type=template&id=0f97a6c7&scoped=true&"
import script from "./Processes.vue?vue&type=script&lang=js&"
export * from "./Processes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f97a6c7",
  null
  
)

export default component.exports